enum RemotionRenderIntent {
  GENERATE_THUMBNAIL = 'GENERATE_THUMBNAIL'
}

export const useRemotionEnvVariables = () => {
  const isGeneratingThumbnail =
    typeof process.env.INTENT === 'string' && process.env.INTENT === RemotionRenderIntent.GENERATE_THUMBNAIL;

  const useMediaBunnyVideoRenderer =
    typeof process.env.USE_MEDIA_BUNNY_RENDERRER === 'string' && process.env.USE_MEDIA_BUNNY_RENDERRER === 'true';

  const burnFrameNumberInRenderOutput =
    typeof process.env.BURN_FRAME_NUMBER_IN_RENDER_OUTPUT === 'string' &&
    process.env.BURN_FRAME_NUMBER_IN_RENDER_OUTPUT === 'true';

  const useSequenceSeriesForPlayRanges =
    typeof process.env.USE_SEQUENCE_AND_SERIES === 'string' && process.env.USE_SEQUENCE_AND_SERIES === 'true';

  return {
    isGeneratingThumbnail,
    useMediaBunnyVideoRenderer,
    burnFrameNumberInRenderOutput,
    useSequenceSeriesForPlayRanges
  };
};
